export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div class="wf-fixed ${this.classes.containerClasses}">
      <wfs-social-proof-bubble
        id="${this.ids.id}"
        class="${this.classes.classes}"
        interval="${this.content.interval}"
        ${this.content.withImage ? 'with-image' : ''}
        filter-by="${this.content.filterBy}"
        filter-ids="${this.content.filterIds}"
        message="${this.content.message}"
        ${this.content.withVerified ? 'with-verified' : ''}
        verified-message="${this.content.verifiedMessage}"
        ${this.content.showAsOffer ? 'show-as-offer' : ''}
        :custom-orders='${this.buildCustomOrders()}'
      />
    </div>`
  }

  buildCustomOrders() {
    if (! this.content.customOrders.length) {
      return []
    }

    return JSON.stringify(this.content.customOrders.map(customOrder => ({
      image: 'imageurl',
      created_at: customOrder.date,
      user: {
        first_name: customOrder.first_name,
        last_name:  customOrder.last_name
      },
      billing_address: {
        city: customOrder.city,
        state: customOrder.state
      },
      items: [
        {
          product: {
            name: customOrder.product
          }
        }
      ]
    })))
  }
}